import { useQuery } from "@tanstack/react-query";
import { getMethod } from "../function/helper";

export default function usePackage() {
  const { isFetching, data: packages } = useQuery({
    queryKey: ["usePackage"],
    queryFn: () =>
      getMethod("/package/v1/list").then(res => {
        if (res && res.status === 200) {
          return res.data;
        }

        return null;
      }),

    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    gcTime: Infinity,
  });

  function getTwoLargestSizes(length, width, height) {
    return [width, height, length].sort((a, b) => b - a).slice(0, 2);
  }

  function getSizes(type, length, width, height) {
    const isSpecialType = [2, 3, 6, 7, 8].includes(type);

    if (isSpecialType) {
      const [first, second] = getTwoLargestSizes(length, width, height);
      return {
        length: first,
        width: second,
        height: 1,
      };
    }

    return {
      length,
      width,
      height,
    };
  }

  const calculatePackagingPrice = ({
    type,
    width,
    length,
    height,
    need = true,
  }) => {
    if (!type || !width || !length || !height || !need || !packages) {
      return 0;
    }

    const sortedPackages = packages
      .filter(item => item.type === type)
      .sort((a, b) => a.mass - b.mass);

    const sizes = getSizes(type, length, width, height);
    const boxMass = sizes.length * sizes.width * sizes.height;

    for (const item of sortedPackages) {
      if (boxMass <= item.mass) {
        return item.price;
      }
    }

    return sortedPackages[sortedPackages.length - 1].price;
  };

  return { isFetching, calculatePackagingPrice, packages };
}
